import { useTranslation } from "react-i18next";
import DangerPic from "../../default_images/danger_deletion.svg";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const EmptyExportWarning = ({ open, setOpen, type = "bookings" }) => {
  const { t } = useTranslation();
  return (
    <TeambookDialog
      onClose={() => setOpen(false)}
      open={open}
      title={" "}
      withCloseButton
      content={
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <img style={{margin: "20px 0px", width: 60, justifySelf: "center"}} alt={"danger"} src={DangerPic}/>
          <p style={{marginBottom: 0}}>{type === "bookings" ? t("dashboard.empty_export_data") : t("dashboard.empty_export_data_logs")}</p>
        </div>
      }
      actionButtons={[
        {
          type: "outlined",
          text: t("close"),
          onClick: () => setOpen(false),
        },
      ]}
    />
  );
};

EmptyExportWarning.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  type: PropTypes.string,
}

export default EmptyExportWarning;
